import React, { useEffect, useState, useReducer, useMemo } from "react"
import AddNewProvider from "./AddNewProvider"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { enumUtil } from "../../../../utils/Enum"
import Loader from "../../../shared/Loader/Loader"
import SearchHeader from "../../Shared/SearchHeader"
import Card from "../../Shared/Card"
import Table from "../../Shared/Table"
import GridColumnHeader from "../../Shared/GridColumnHeader"
import Pagination from "../../../shared/Pagination/Pagination"
import { connect, useDispatch, useSelector } from "react-redux"
import handleCopyText from "../../../shared/CopyData"
import isNull from "../../../../utils/NullChecking"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
import usePagination from "../../../../customhooks/usePagination"
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList"
import useUserData from "../../../hooks/useUserData"

const Provider = (props) => {
    const { type, Settings } = { ...props };
    const { paginationSection, PerPage, PageNo, TotalPages, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages, handleSelectData } = usePagination(Settings.PaginationDefaultRows);
    const Search_Data = {
        Search: '',
        Active: ''
    }
    let dispatch = useDispatch();
    const { handleLoadUserData } = useUserData();
    let statusOption = [{ value: '', display: "" }, { value: true, display: "Active" }, { value: false, display: "Inactive" }]
    let IsDeleteAllowed = FindSecondChild('Setup', 'Account', 'Provider')?.IsDeleted
    const API_URL = enumUtil.controller.General
    const [isOpenProvider, setIsOpenProvider] = useState(false)
    const [providerData, setProviderData] = useState([]);
    const [ProviderID, setProviderID] = useState();
    const [searchParam, setSearchParam] = useState(Search_Data);
    const [EnterParam, setEnterParam] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isClose, setIsClose] = useState(false);
    const [show, setShow] = useState(Settings?.DefaultPageView === "Card View" ? true : false);
    const [totalCounts, setTotalCounts] = useState(false)
    const [copiedText, setCopiedText] = useState({});
    const [ActiveSeach, setActiveSearch] = useState('')
    const searchButton = {
        AddNew: true,
        Excel: false,
        PDF: false,
        Delete: false,
        Filter: false,
        View: true
    }
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)
    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    //////////////////////////////////////////////
    //For Pagination
    // const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
    // const [PageNo, setPageNo] = useState(1);
    // const [TotalPages, setTotalPages] = useState();
    const [totalCount, setTotalCount] = useState();
    const [searchParamType, setSearchparamType] = useState("");
    // const handlePageClick = (page) => { setPageNo(page); }
    // const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    // const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    // const handleFingByCreteria = (e) => {
    //     setPerPage(e.target.value)
    //     setPageNo(1)
    // }
    ///////////


    const SearchByParam = () => {
        if (!isNull(searchParam)) {
            // setPageNo('1')
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            SearchByParam(searchParam, "searchParam")
        }
    }
    const [npiModal, setNpiModal] = useState(false)
    const onCloseProocedNpi = () => {
        setNpiModal(false)
    }
    const proceedHeader = () => {
        return <p className="heading">Proceed with NPI Registry</p>;
    };
    useEffect(() => {
        LoadData(searchParam);
    }, [PerPage, PageNo])
    useEffect(() => {
        LoadData(searchParam);
    }, [isClose])
    const AddProvider = (ID) => {
        setIsOpenProvider(true)
        setNpiModal(true)
        setProviderID(ID)
    }

    const CloseProvider = () => {
        setIsOpenProvider(false)
        setNpiModal(false)
    }
    const DeleteProvider = () => {
        setIsOpenProvider(false)
        handleLoadUserData();
        let pgDlt = totalCount % PerPage
        PageNo(pgDlt === 1 ? PageNo !== 1 ? PageNo - 1 : PageNo : PageNo)
        setIsClose(!isClose);
    }
    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        console.log("Name", type)
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }
    const columns = [

        {
            key: 'Name',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-location'} headerName={'Name'} sortIcon={true} type={'string'} colKey={'Name'} data={providerData} setData={setProviderData} />),
            renderCell: ({ row }) => {
                return (
                    <button className="btn btn-link w-100 p-0" >
                        <div className="d-flex copy_icon_hover justify-content-between w-100 align-items-center copy_icon gap-1">
                            <div className="validation_message" onClick={() => AddProvider(row.ProviderID)}>{row.Name} </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.ProviderID, row.Name)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.ProviderID}-${row.Name}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </button>
                );
            },
        },
        {
            key: 'NPI',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'NPI'} sortIcon={true} type={'number'} colKey={'NPI'} data={providerData} setData={setProviderData} />),
            width: 120,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.NPI}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.ProviderID, row.NPI)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.ProviderID}-${row.NPI}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            },
        },
        {
            key: 'SSN',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'SSN'} sortIcon={true} type={'number'} colKey={'SSN'} data={providerData} setData={setProviderData} />),
            width: 120,
        },
        {
            key: 'TaxonomyCode',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Taxonomy Code'} sortIcon={true} type={'number'} colKey={'TaxonomyCode'} data={providerData} setData={setProviderData} />),
            width: 150,
        },
        {
            key: 'PhoneNumber',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Phone Number'} sortIcon={true} type={'number'} colKey={'PhoneNumber'} data={providerData} setData={setProviderData} />),
            width: 150,
        },
        {
            key: 'Address',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Address'} sortIcon={true} type={'string'} colKey={'Address'} data={providerData} setData={setProviderData} />),
            flex: 1,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.Address}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopyText(row.Address)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                        </div>
                    </>
                );
            }
        },
    ];
    const LoadData = (param, types) => {
        setIsLoading(true)
        // setProviderData([])
        if (types) {
            setSearchparamType(types)
        } else {
            setSearchparamType("")
        }
        const SearchPageNo = !param;
        ServerRequestProtected(API_URL + "/FindBySingleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.Provider,
            "SearchCriteria": param,
            "PerPage": PerPage,
            "PageNo": SearchPageNo ? PageNo : 1,
        }).then((response) => {
            setTotalCounts(response.Rows.length)
            setIsLoading(false)
            setProviderData(response.Rows)
            handleGridHeader({ defaultData: response.Rows })
            setTotalPages(response.count.NumOfPages);
            if (type && type === "Wizard") {
                if (response.Rows?.length == 0 && isNull(searchParamType)) {
                    setIsOpenProvider(true)
                }
            }
        }).catch((error) => {
            setProviderData([])
            setTotalCounts(0)
            setIsLoading(false)
            if (type && type === "Wizard") {
                if (providerData?.length == 0 && isNull(searchParamType)) {
                    setIsOpenProvider(true)
                }
            }
        })
    }
    let PopupScreen = "";
    if (isOpenProvider) {
        PopupScreen = <AddNewProvider isOpenProvider={isOpenProvider} onClose={CloseProvider}
            onDeleteProvider={DeleteProvider} ProviderID={ProviderID}
            npiModal={npiModal} proceedHeader={proceedHeader} onCloseProocedNpi={onCloseProocedNpi} type={type}
        />

    }
    const CardView = () => {
        setShow(true)
        setNpiModal(false)
        // setPerPage(-1)
    };
    const TableView = () => {
        setShow(false)
        // setPerPage(10)
    };
    const rowClass = () => { return "row-bg" }
    const handleExcel = () => { }
    const handlePdf = () => { }
    const handleFilter = () => { }
    const handleDelete = () => { }
    const handleClearSearch = () => {
        setSearchParam({ ...searchParam, Search: '' })
    }

    const handleClear = () => {
        setActiveSearch('')
        setSearchParam({ ...searchParam, Search: '', Active: '' })

    }

    const handleSelectedDataa = (selectedData, name, type) => {
        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'Active') {
                setSearchParam({
                    ...searchParam,
                    Active: selectedData.value + "",
                });

                setActiveSearch(selectedData.display);

            }
        }

        return selectedData;
    }
    const handleChange = (e) => {
        let { name, value } = e.target

        if (name === 'Active') {
            setActiveSearch(value)
        }

    }
    const ProviderBody = () => {
        return (
            <>
                <div className={show ? 'container-fluid action-row br-bottom-1 br-clr' : 'container-fluid action-row br-clr'}>
                    <div className="row justify-content-between">
                        <div className="col-4 form-rounded">
                            <div className="input">
                                <div className='input-group hk-input-search'>
                                    <input type="text" className='form-control fc-xs'
                                        placeholder='Search by name or id…'
                                        onChange={(e) => { setSearchParam({ ...searchParam, Search: e.target.value }) }}
                                        onKeyDown={SearchOnEnter}
                                        value={searchParam.Search} />
                                    {searchParam?.Search?.length > 0 ?
                                        <span className="input-group-text" id="basic-addon2" onClick={handleClearSearch}>
                                            <i className="bi bi-x"></i>
                                        </span> : <span className="input-group-text" id="basic-addon2" onClick={SearchByParam}>
                                            <i className="bi bi-search"></i>
                                        </span>}
                                </div>
                            </div>

                        </div>
                        <div className="col-md-3 multipleSearch-rounded ps-0">
                            <div className="input race">
                                {/* <label >Status</label> */}
                                <SuperSearchList
                                    type="client"
                                    id='Active'
                                    name='Active'
                                    searchValue={ActiveSeach}
                                    data={statusOption}
                                    onChange={(e) => handleChange(e)}
                                    getSelectedData={handleSelectedDataa}
                                    // is={is}
                                    icon={'Simple'}
                                    sup_btn='sup_btn'
                                    sup_inp='superSearchVisitInp'
                                    className="form-control rounded"
                                    placeholder='Search Status'
                                />
                            </div>
                        </div>
                        <div className="col-md-5 d-flex align-items-end justify-content-between gap-10">
                            <div className='btns-group-flex flex-nowrap'>
                                {/*  */}
                                <button className='btn btn-orange btn-xs no-width rounded' onClick={() => LoadData(searchParam)} >Search</button>
                                <div className='line-border'></div>
                                {/*  */}
                                <button className='btn btn-outline btn-xs no-width rounded' onClick={() => handleClear()} >Clear</button>
                            </div>
                            <div className=" ps-0">
                                <SearchHeader
                                    AddNew={AddProvider}
                                    Excel={handleExcel}
                                    PDF={handlePdf}
                                    Delete={handleDelete}
                                    Filter={handleFilter}
                                    cardView={CardView}
                                    tableView={TableView}
                                    show={show}
                                    searchButton={searchButton}
                                    Key={613}
                                    Name={'Provider'}
                                    // Counts={totalCounts}
                                />
                            </div>
                        </div>

                    </div>
                </div>
                {show ?
                    <>
                        <Card
                            AddNew={AddProvider}
                            Data={providerData}
                            ID={ProviderID}
                            dropDown={DropDowns?.Provider}
                            API_URL={API_URL}
                            TableName={enumUtil.enumAPITableName.Provider}
                            handleDelete={DeleteProvider}
                            isLoading={isLoading}
                            Key={613}
                            Name={'Provider'}
                            IsDeleteAllowed={IsDeleteAllowed}
                        />
                        {paginationSection}
                        {/* <Pagination
                        PerPage={PerPage}
                        PageNo={PageNo}
                        TotalPages={TotalPages}
                        handlePageClick={handlePageClick}
                        PreviousPage={PreviousPage}
                        handleFingByCreteria={handleFingByCreteria}
                        NextPage={NextPage}
                    /> */}
                    </>
                    : (
                        <div className="table-view SetupTable location_grid">
                            <Table
                                columns={columns}
                                rows={providerData}
                                height='500px'
                                rowClass={rowClass}
                                // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table'
                                dynamicClass='fill-grid DataGrid-Table hk-exp-table'
                                rowHeight={25}
                                PerPage={PerPage}
                                PageNo={PageNo}
                                TotalPages={TotalPages}
                                handlePageClick={handlePageClick}
                                PreviousPage={PreviousPage}
                                handleFingByCreteria={handleFingByCreteria}
                                NextPage={NextPage}
                                Key={613}
                                Name={'Provider'}
                                isLoading={isLoading}
                                TableName={'Provider'}
                                handleSelectData={handleSelectData}
                                LoadData={() => LoadData(searchParam)}
                                ClearSearch={handleClearSearch}
                            />
                        </div>
                    )
                }
            </>
        )
    }
    // useEffect(()=>{
    //     if(type && type === "Wizard"){
    //         if(providerData?.length == 0 && isNull(searchParamType)){
    //             setIsOpenProvider(true)
    //         }       
    //     }
    // },[providerData, searchParamType])
    return (
        <React.Fragment>
            {/* {PopupScreen} */}
            {isLoading ? <Loader /> : null}
            {type && type === "Wizard" ?
                <>
                    {/* {providerData?.length > 0 || !isNull(searchParamType) ? */}
                    <>
                        {isOpenProvider ? <>{PopupScreen}</> : <>{ProviderBody()}</>}
                    </>
                    {/* : <>{PopupScreen}</> */}
                    {/* } */}
                </> :
                <>
                    {PopupScreen}
                    {ProviderBody()}
                </>
            }


        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        Settings: state.SettingsReducer,
    }
}

export default connect(mapStateToProps)(Provider);